import React, { Fragment, useContext, useEffect, useState } from "react";
import { APIContext } from "../../Contexts/APIContext";
import { MsalContext } from "../../Contexts/MsalContext";
import FeedbackRowViewModel from "../ViewModels/FeedbackRowViewModel";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import FeedbackTableFiltersViewModel from "../ViewModels/FeedbackTableFiltersViewModel";
import FeedbackPage from "../Shared/FeedbackPage";
import FeedbackFilterBar from "../Shared/FeedbackFilterBar";
import FeedbackTable from "../Shared/FeedbackTable";
import { CircularProgress } from "@mui/material";

interface IFeedbackContainerProps {
    view: string
}

export default function FeedbackContainer(props: IFeedbackContainerProps) {

    const { msalFetch } = useContext(MsalContext);
    const { post } = useContext(APIContext);
    const [feedbackRows, setFeedbackRows] = useState<FeedbackRowViewModel[]>([])
    const [callRefId, setCallRefId] = useState<string | null>(null);
    const [completeId, setCompleteId] = useState<number | null>(null);
    const [filters, setFilters] = useState(new FeedbackTableFiltersViewModel("", [], props.view));
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);
    const [loadingFeedback, setLoadingFeedback] = useState<boolean>(false);

    useEffect(() => {
        msalFetch(`api/User/GetClientList`)
            .then(response => response.json())
            .then((data: any) =>
                setFilters(new FeedbackTableFiltersViewModel(data[0], [], props.view))
            );
    }, []);

    useEffect(() => {
        if (filters.client !== "") getFeedbackData();
    }, [filters, page, rowsPerPage]);

    const getFeedbackData = () => {
        setLoadingFeedback(true);
        post('Feedback',
            `GetFilteredFeedback?page=${page}&rowsPerPage=${rowsPerPage}`
            ,
            filters,
            (data) => {
                setFeedbackRows(data.rows);
                setCount(data.count);
                setLoadingFeedback(false);
            });
    }

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    }

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    const handleFeedbackOpen = (callRefId: string, completeId: number) => {
        setCallRefId(callRefId);
        setCompleteId(completeId);
    }

    const handleFeedbackClose = () => {
        setCallRefId(null);
        setCompleteId(null)
        getFeedbackData();
    }

    const updateFilters = (filters: FeedbackTableFiltersViewModel) => setFilters(filters);

    const updateFilterValue = (filterName: string, value: any) => {
        setFilters({
            ...filters,
            [filterName]: value
        })
    }

    const removeFilter = (filterFlag: string, filterNames?: string[]) => {
        const filt = { ...filters };

        filt[filterFlag] = false;

        if (filterNames) {
            for (const name of filterNames) {
                if (typeof filt[name] === "string") {
                    filt[name] = "";
                } else if (Array.isArray(filt[name])) {
                    filt[name] = [];
                } else if (typeof filt[name] === "number") {
                    if (name === 'callLengthMax') {
                        filt[name] = 606;
                    } else {
                        filt[name] = 0;
                    }
                } else {
                    filt[name] = null;
                }
            }
        }
        updateFilters(filt);
    }

    return (
        <Fragment>
            <Dialog
                open={callRefId !== null && completeId !== null}
                onClose={handleFeedbackClose}
                fullScreen
            >
                {callRefId && completeId &&
                    <FeedbackPage
                        view={props.view}
                        callRefId={callRefId}
                        setCallRefId={setCallRefId}
                        completeId={completeId}
                        close={handleFeedbackClose}
                        status={feedbackRows.find(feedback => feedback.completeId === completeId)?.status}
                        agentHasRepsonded={!!feedbackRows.find(feedback => feedback.completeId === completeId)?.dateAgentResponded}
                    />
                }
            </Dialog>
            <Grid size={12}>
                <FeedbackFilterBar
                    view={props.view}
                    filters={filters}
                    updateFilters={updateFilters}
                    updateFilterValue={updateFilterValue}
                    applyFilters={getFeedbackData}
                    removeFilter={removeFilter} />
            </Grid>
            {
                !loadingFeedback ?
                    <FeedbackTable
                        view={props.view}
                        feedbackRows={feedbackRows}
                        handleFeedbackOpen={handleFeedbackOpen}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        page={page}
                        count={count}
                        rowsPerPage={rowsPerPage}
                    />
                    :
                    <Grid container justifyContent="center" alignItems="center" sx={{ height: "50%" }}>
                        <Grid>
                            <CircularProgress size={100} />
                        </Grid>
                    </Grid>
            }
        </Fragment>
    );
}